<template >
  <div>
    <el-form v-model="formDate" label-width="150px">
      <el-row style="text-align: center;height: 30px;line-height: 30px;">
        <el-col :span="2" :offset="3" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
          序号
        </el-col>
        <el-col :span="4" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
          时间段类型
        </el-col>
        <el-col :span="7" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
          开始时间
        </el-col>
        <el-col :span="7" style="font-weight:bold;border:groove 1px #e0dddd;background-color: #F5F7FA;">
          结束时间
        </el-col>
      </el-row>
      <el-row v-for="(item,index) in this.timeSettingList" :key="item.nanoid" style="text-align: center;height:30px;line-height: 30px;margin-top: 10px">
          <el-col :span="3">
            <el-button v-if="index > 0" circle type="danger"  @click="removeOneTimeSetting(item.nanoid)">
              <el-icon :size="20">
                <Close />
              </el-icon>
            </el-button>
          </el-col>
          <el-col :span="2"  style="text-align: center;">
            {{ index + 1 }}
          </el-col>
        <el-col :span="4">
          <el-select v-model="item.time_type" placeholder="时间段类型">
            <el-option v-for="item1 in this.timeTypeList" :value="item1.value" :key="item1.value" :label="item1.name"></el-option>
          </el-select>
        </el-col>
        <el-col :span="7">
          <el-time-picker format="HH:mm" :value-format="'HH:mm'" v-model="item.start_time" ></el-time-picker>
        </el-col>
        <el-col :span="7">
          <el-time-picker format="HH:mm" value-format="HH:mm" v-model="item.end_time" >
          </el-time-picker>
        </el-col>
      </el-row>
      <el-row style="text-align: center;margin-top: 10px">
        <el-col :span="3">
          <el-button type="primary" circle @click="addOneTimeSetting()">
            <el-icon  :size="20">
              <Plus />
            </el-icon>
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row style="justify-content: center;width: 90%;margin-top: 10px">
      <el-button type="primary" @click="submit">保存</el-button>
    </el-row>
  </div>
</template>

<script>

import {Bottom, Close, Plus, Top} from "@element-plus/icons-vue";
import {nanoid} from "nanoid";

export default {
  name: "TimeSetting",
  components: {Bottom, Top, Plus, Close},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      formDate: {},
      timeSettingList:[]

    };
  },
  computed: {
    timeTypeList() {
      return this.$store.getters['core/getDictList']('mes_mold_time_type');
    },
  },
  created() {
    this.getTimeSetting();
  },
  mounted() {
  },

  methods: {
    async submit() {

      for (let i = 0; i < this.timeSettingList.length; i++){
        let index = i+1;
        let obj = this.timeSettingList[i];

        if (!(!obj.time_type && !obj.start_time && !obj.end_time)){
          if (!obj.time_type) {
            this.$message.error("序号" + index + "请选择时间段类型！")
            return
          }
          if (!obj.start_time) {
            this.$message.error("序号" + index + "请填写开始时间！")
            return
          }
          if (!obj.end_time) {
            this.$message.error("序号" + index + "请填写结束时间！")
            return
          }
        }
      }
      this.timeSettingList = this.timeSettingList.filter(item => item.time_type ||
          item.start_time || item.end_time);

      this.formDate.timeSettingList = this.timeSettingList;
      await this.$http('mesMoldMmCreateService.submitTimeSetting',this.formDate)
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },


    //获取时间设置
    async getTimeSetting() {
      let res = await this.$http('mesMoldMmDsService.getTimeSetting');
      if (res.timeSettingList){
        this.timeSettingList = res.timeSettingList;
      }else {
        this.addFiveTimeSetting();
      }
    },

    async addFiveTimeSetting() {
      let i = 0;
      while (i < 5){
        this.addOneTimeSetting();
        i++;
      }
    },

    //添加时间设置
    addOneTimeSetting() {
      this.timeSettingList.push({
        nanoid: nanoid(),
      })
    },

    //删除时间设置
    removeOneTimeSetting(nanoid) {
      let index = this.timeSettingList.findIndex(item => item.nanoid === nanoid);
      if (index > 0) {
        this.timeSettingList.splice(index, 1);
      }
    },

  },
}
</script>

<style lang="less" scoped>
.graph_container {
  background-color: white;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 20px;
}

.startPageClass {
  color: #00afff;
  margin-left: 30px;
  width: 400px;
  justify-content: left
}

</style>